import { defaultHrmAttendDailyDto, HrmAttendDailyDto } from 'src/dtos/hrmAttendDaily/hrmAttendDailyDto';
import { defaultHrmAttendEventDto, HrmAttendEventDto } from 'src/dtos/hrmAttendEvent/hrmAttendEventDto';

/** 일일근태 조회·저장·계산 요청과 일괄 응답이다. */
export interface HRM2010_R01Dto {
    workDt: string; // 근무일자
    compCd: string; // 사업장 조회 조건
    orgCd: string; // 부서 조회 조건
    attendCd: string; // 근태 조회 조건
    outYn: string; // 외출 있음 조건
    shiftCd: string; // 근무조 조회 조건
    listLength: number; // 현재 목록 길이
    refetchListLength: number; // 재조회 전 목록 길이
    hrmAttendDailyDtoList: HRM2010_R01HeaderDto[]; // 저장·계산할 일일근태 행
    deletedEmpNoList: string[]; // 삭제할 사원번호
    eventEmpNo: string; // 외출 기록이 속한 사원번호
    hrmAttendEventDtoList: HRM2010_R01DetailDto[] | null; // null이면 DB 기록을 사용
    createdCount: number; // 일괄 정상출근 생성 건수
    skippedEmpNmList: string[]; // 근무조 미배정으로 제외한 사원명
}

/** 일일근태 행에 조회용 표시값을 더한다. */
export interface HRM2010_R01HeaderDto extends HrmAttendDailyDto {
    empNm: string; // 사원명
    orgNm: string; // 부서명
    shiftNm: string; // 근무조명
    attendNm: string; // 근태명
    attendGroup: string; // 근태구분
    isNightShift: boolean; // 야간 근무조이면 true
    isAttendMissing: boolean; // 근태가 없는 재직자로 조회 시 만든 미입력 행이면 true. 화면 표시용이며 저장하지 않는다
}

/** 외출·복귀 기록에 조회용 근태 표시값을 더한다. */
export interface HRM2010_R01DetailDto extends HrmAttendEventDto {
    attendNm: string; // 근태명
    attendGroup: string; // 근태구분
    workYn: string; // 근무 인정 여부
}

/** 외출 요약 표시용 짝이다. */
export interface HRM2010_R01OutPair {
    attendCd: string; // 외출 코드
    fromTime: string | null; // 외출 시각
    toTime: string | null; // 복귀 시각
    errorMessage: string | null; // 짝 오류 문장
}

/** 일일근태 행 기본값이다. */
export const defaultHRM2010_R01HeaderDto: HRM2010_R01HeaderDto = {
    ...defaultHrmAttendDailyDto,
    empNm: '', orgNm: '', shiftNm: '', attendNm: '', attendGroup: '', isNightShift: false, isAttendMissing: false,
};
/** 외출·복귀 행 기본값이다. */
export const defaultHRM2010_R01DetailDto: HRM2010_R01DetailDto = {
    ...defaultHrmAttendEventDto,
    attendNm: '', attendGroup: '', workYn: '',
};
/** 빈 저장·계산 요청이다. */
export const defaultHRM2010_R01Dto: HRM2010_R01Dto = {
    workDt: '', compCd: '', orgCd: '', attendCd: '', outYn: '', shiftCd: '',
    listLength: 0, refetchListLength: 0, hrmAttendDailyDtoList: [],
    deletedEmpNoList: [], eventEmpNo: '', hrmAttendEventDtoList: null,
    createdCount: 0, skippedEmpNmList: [],
};
